module.exports = "/wwwroot/img/contact_page.png?ver=538c5bd0";